import { CloseButton, Popover, PopoverButton, PopoverPanel } from '@headlessui/react';
import { inputClass } from '@shared/components/form-styles';
import { COLORS } from './colors';

type ColorInputProps = {
  value: string;
  onChange: (value: string) => void;
};

export function ColorInput({ value, onChange }: ColorInputProps) {
  return (
    <Popover className="relative">
      <PopoverButton className={`${inputClass} w-9 h-9 flex items-center justify-center`}>
        <div className="w-5 h-5 rounded-full" style={{ backgroundColor: value }} />
      </PopoverButton>
      <PopoverPanel
        anchor="bottom start"
        className="grid grid-cols-5 gap-2 bg-popover rounded-md p-2 shadow-popover z-popover"
      >
        {COLORS.map((color, index) => (
          <CloseButton
            key={`${index}-${color}`}
            onClick={() => onChange(color)}
            className={`${inputClass} w-9 h-9 flex items-center justify-center`}
          >
            <ColorPill color={color} />
          </CloseButton>
        ))}
      </PopoverPanel>
    </Popover>
  );
}

type ColorPillProps = {
  color: string;
};

function ColorPill({ color }: ColorPillProps) {
  return <div className="w-5 h-5 rounded-full" style={{ backgroundColor: color }} />;
}
